import React from 'react';
import { Icon } from 'components';
import { Alert } from '@brokerbay/design-components';
import styled from 'styled-components';

const NoAccessAlert = () => (
    <StyledWrapper>
      <Alert
        dataCy="noAccess-page-alert"
        message={
          <span>
            You do not have access to this feature. Please reach out to your
            managing broker to finish setting up your brokerage.
          </span>
        }
        type="warning"
        showIcon
        icon={
          <Icon type="antdExclamationCircleFilled" color="warning" width={14} />
        }
      />
    </StyledWrapper>
  );

export default NoAccessAlert;

const StyledWrapper = styled.div`
  margin-bottom: 5px;
`;
